"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocaleManager = /** @class */ (function () {
    function LocaleManager() {
    }
    LocaleManager.prototype.set = function (configs, defaultConfig) {
        this.configs = configs;
        this.list = configs.reduce(function (acc, curr) {
            acc[curr.messages] = curr;
            return acc;
        }, {});
        this.defaultConfig = defaultConfig;
    };
    LocaleManager.prototype.setExtensions = function (extensions) {
        this.extensions = extensions;
    };
    LocaleManager.prototype.convert = function (value, _a) {
        var from = _a.from, to = _a.to;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var currConfig = this.configs.find(function (item) {
            var itemValue = item[from];
            return Array.isArray(itemValue)
                ? itemValue.includes(value)
                : itemValue === value;
        }) || this.defaultConfig;
        return currConfig[to];
    };
    LocaleManager.prototype.getItemByDataFeed = function (items, _a) {
        var from = _a.from, value = _a.value, predicate = _a.predicate;
        var dataFeed;
        if (from === 'dataFeed') {
            dataFeed = [value];
        }
        else {
            dataFeed = this.convert(value, {
                from: from,
                to: 'dataFeed',
            } // NOTE: don't remove "as any".
            );
        }
        var item = dataFeed.reduce(function (acc, dataFeedLocale) {
            return (acc ||
                items.find(function (currItem) { return predicate(currItem) === dataFeedLocale; }));
        }, undefined);
        return item;
    };
    return LocaleManager;
}());
exports.default = new LocaleManager();
//# sourceMappingURL=LocaleManager.js.map